import CustomAvatar from '@/@core/components/mui/Avatar'
import { IUser, UserTypeEnum } from '@/@data'
import { getInitials } from '@/utils/getInitials'
import { SxProps, Theme, Tooltip, Typography } from '@mui/material'
import Link from '../Link'

const getAvatar = (params: Pick<IUser, 'avatar_file' | 'first_name'>) => {
  const { avatar_file, first_name } = params

  if (avatar_file) {
    return <CustomAvatar src={avatar_file.tiny_url} skin='light' size={34} />
  } else {
    return (
      <CustomAvatar skin='light' size={34}>
        {getInitials(first_name as string)}
      </CustomAvatar>
    )
  }
}

export const UserAvatar = ({ user, link, sx }: { user: IUser; link?: string; sx?: SxProps<Theme> }) => {
  return (
    <Link href={link || `/cms/users/employee/${user?.id}`} className='flex items-center gap-4 '>
      {getAvatar({ avatar_file: user?.avatar_file, first_name: user?.first_name || user?.employee_name || '-' })}
      <div className='flex flex-col'>
        <Tooltip title={user?.first_name || user?.employee_name || '-'} placement='top' arrow>
          <Typography
            className='font-medium max-w-[200px] whitespace-nowrap overflow-hidden text-ellipsis text-bold'
            color='text.primary'
            sx={sx}
          >
            {user?.first_name || user?.employee_name || '-'}
          </Typography>
        </Tooltip>
        {user?.user_type === UserTypeEnum.User && (
          <Typography variant='body2'> {`(${user?.phone_code || '+84'}) ${user?.phone || '-'}`}</Typography>
        )}{' '}
        {user?.user_type === UserTypeEnum.Admin && <Typography variant='body2'>{user?.email || '-'}</Typography>}
      </div>
    </Link>
  )
}
